<!--
2023-11-02 YTW 印度排灯节
-->
<template>
  <div class="outScreen" id="outScreen">
    <div class="main-content"
         :style="{backgroundImage:'url('+require('../../assets/images/anniversary/background.png')+')'}">
      <div class="topBanner"><img :src="banner"/></div>
      <div class="topBack">
        <img :src="back" alt="" @click="goBack" class="back">
      </div>
      <div class="content1" v-show="shareLink">
        <div class="cosmic">
          <img :src="cosmic">
        </div>
        <div class="sunlight">
          <img :src="sunlight">
        </div>
        <div class="event1">
          <div class="e-img"><img :src="event1">
            <div class="word">{{ $t('lang.anniversary.event') }}1</div>
          </div>
          <div class="desc">
            <img :src="coinHill" class="img1"/>
            <div class="desc_word shadow">
              <div class="sentenceBox1">
                <span v-html="$t('lang.anniversary.sentence1').replace(/{link}/g,shareLink)"></span>
                <div :class="'copyCss'+$store.state.locale">
                  <img
                    src="https://betapp-images.s3.ap-northeast-1.amazonaws.com/Homebanner/b7jnbm6uf8laxzirxrhpwyn7wz21luvkcopy.svg"
                    @click="copyUrl"/></div>
              </div>
              <div class="sentenceBox1"><span v-html="$t('lang.anniversary.sentence2')"></span></div>
              <div class="sentenceBox1"><span v-html="$t('lang.anniversary.sentence3')"></span></div>
            </div>
            <div class="desc_btn" :style="$store.state.locale==='EN'?'bottom:4vw':'bottom:-2vw'">
              <div class="btn" @click="shareUrl">{{ $t('lang.affiliate.share') }}</div>
              <div class="btn" v-if="canCollect" @click="claimNow">{{ $t('lang.account.claim') }}</div>
              <div class="btn-disable" v-else>{{ $t('lang.account.claim') }}</div>
            </div>
          </div>
        </div>
        <div class="event2">
          <div class="e-img"><img :src="event2">
            <div class="word">{{ $t('lang.anniversary.event') }}2</div>
          </div>
          <div class="desc">
            <div class="sentenceBox2 shadow">
              <span v-for="(item,index) in $t('lang.anniversary.word4Event2')" v-html="item" :key="index"/>
            </div>
            <div class="imgBox2">
              <img :src="nameCard"/>
            </div>
          </div>
        </div>
        <div class="event3">
          <div class="e-img"><img :src="event3">
            <div class="word">{{ $t('lang.anniversary.event') }}3</div>
          </div>
          <div class="desc">
            <div class="sentenceBox3 shadow">
              <span v-for="(item,index) in $t('lang.anniversary.word4Event3')" v-html="item" :key="index"/>
            </div>
            <div class="imgBox3">
              <img :src="thirdCard"/>
            </div>
            <div class="btnBox">
              <div class="btn" @click="goFB">{{ $t('lang.rule.Go') }}</div>
            </div>
          </div>
        </div>
        <div class="newspaper">
          <img src="https://betapp-images.s3.ap-northeast-1.amazonaws.com/Homebanner/ce6uafsrv5d2u8mctole15wo7gyiq0rd5th3.webp">
        </div>
        <div class="bottom">
          <div class="bottom-word shadow">
            <span v-html="$t('lang.anniversary.bottomWord')"/>
          </div>
          <div class="bottom-img">
            <img :src="top" @click="toTop">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import top from '@/assets/images/anniversary/top.svg'
import back from '@/assets/images/anniversary/back.svg'
import copy from '@/assets/images/anniversary/copy.svg'
import banner from '@/assets/images/anniversary/banner.png'
import event1 from '@/assets/images/anniversary/event1.svg'
import event2 from '@/assets/images/anniversary/event2.svg'
import event3 from '@/assets/images/anniversary/event3.svg'
import cosmic from '@/assets/images/anniversary/cosmic.png'
import coinHill from '@/assets/images/anniversary/coinHill.png'
import sunlight from '@/assets/images/anniversary/sunlight.png'
import nameCard from '@/assets/images/anniversary/nameCard.png'
import newspaper from '@/assets/images/anniversary/newspaper.png'
import thirdCard from '@/assets/images/anniversary/thirdCard.png'
import {Toast} from 'mint-ui'
import request from '@/service'
// import {initFbsdk} from '@/config/facebookOAuth.js'
export default {
  name: 'FifthAnniversary',
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      top,
      back,
      copy,
      banner,
      event1,
      event2,
      event3,
      cosmic,
      coinHill,
      sunlight,
      nameCard,
      newspaper,
      thirdCard,
      shareLink: '',
      canCollect: false
    }
  },
  components: {
  },
  watch: {
  },
  mounted () {
    if (!this.userInfo) {
      this.$router.push('/Login')
      return
    }
    // this.initFB()
    this.fetchData()
    this.fetchAccount()
  },
  updated () {
  },
  destroyed () {
  },
  methods: {
    // initFB () {
    //   const url = '/innovation/account/getsystemsettings'
    //   const data = {
    //     FacebookId: 'FacebookAppId'
    //   }
    //   request('post', url, data).then(res => {
    //     initFbsdk(res)
    //   }).catch((e) => {
    //     console.log(' === facebook exception ', e)
    //   })
    // },
    fetchData () {
      const url = '/innovation/anniversary/data'
      const data = {
        UserId: this.userInfo.UserId
      }
      request('post', url, data).then(res => {
        if (res && res.Status === 0) {
          this.canCollect = true
        } else {
          this.canCollect = false
        }
      }).catch(err => {
        console.log(err)
      })
    },
    fetchAccount () {
      const url = '/innovation/account/getuseraccount'
      const data = {
        userId: this.userInfo.UserId
      }
      request('post', url, data).then(res => {
        this.shareLink = res.InviteLink + '&f=n'
      }).catch(err => {
        console.log(err)
      })
    },
    goFB () {
      window.location.href = 'https://www.facebook.com/PGEbet/'
    },
    copyShares () {
      const shareText = this.$t('lang.anniversary.copyTextArr')[Math.floor(Math.random() * 5)]
      // const message = this.$t('lang.anniversary.shareWords') + this.shareLink
      const message = shareText + this.shareLink
      let copyBehavior = function (e) {
        e.clipboardData.setData('text/plain', message)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', copyBehavior)
      document.execCommand('copy')
    },
    shareUrl () {
      this.copyShares()
      window.open(`https://www.facebook.com/sharer.php?u=` + this.shareLink + '&quote=' + this.$t('lang.anniversary.shareWords') + this.shareLink, '_blank')
      // window.FB.ui(
      //   {
      //     method: 'share',
      //     href: this.shareLink,
      //     quote: this.$t('lang.anniversary.shareWords') + this.shareLink
      //   },
      //   // callback
      //   function (response) {
      //     if (response && !response.error_message) {
      //       alert('Posting completed.')
      //     } else {
      //       alert('Error while posting.')
      //     }
      //   }
      // )
    },
    claimNow () {
      const url = '/innovation/anniversary/collect_reward'
      const data = {
        UserId: this.userInfo.UserId
      }
      request('post', url, data).then(res => {
        if (res && res.Reward > 0) {
          Toast(this.$t('lang.account.currencyType') + res.Reward + ' ' + this.$t('lang.dailyFreeCash.giftReward'))
          this.fetchData()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    copyUrl () {
      this.copyShares()
      Toast(this.$t('lang.inviteFriends.success'))
    },
    goBack () {
      this.$router.go(-1)
    },
    toTop () {
      const element = document.getElementById('outScreen')
      this.$el.scrollTop = element.offsetTop
    }
  }
}
</script>

<style lang="less" scoped>
.outScreen {
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.main-content {
  position: relative;
  top: 56px;
  height: 685vw;
  background-color: #161413;
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
  background-position: top;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .topBack {
    position: absolute;
    top: 2.5vh;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-left: 5vw;

    img {
      width: 5vw;
    }
  }
  .topBanner{
    position: relative;
    top: 0;
    width: 100%;
    height: max-content;

    img {
      width: 100%
    }
  }
  .content1{
    width: 100%;

    .event1 {
      padding: 5.833vw 0 0 7.222vw;
      width: 100%;
      height: max-content;

      .e-img {
        position: relative;
        width: 85.277vw;

        img {
          width: 100%;
        }

        .word {
          position: absolute;
          top: 0;
          left: 15vw;
          color: #FFFFFF;
          text-shadow: 0px 0.35vw 0.35vw #BFBFBF;
          font-size: 5.833vw;
          font-style: italic;
          font-weight: 700;
          text-transform: capitalize;
        }
      }

      .desc {
        position: relative;
        height: 63.888vw;

        .img1 {
          position: absolute;
          top: 2vw;
          right: 0;
          height: 46.667vw;
        }

        @media screen and (max-width: 400px) {
          .desc_word {
            margin-top: 2vw;
            width: 70vw;
            color: #FFD600;
            font-size: 3.888vw;
            line-height: 6.35vw;
            font-weight: 400;
            letter-spacing: 0.015em;
          }
        }
        @media screen and (min-width: 401px) {
          .desc_word {
            margin-top: 2vw;
            width: 70vw;
            color: #FFD600;
            font-size: 3.888vw;
            line-height: 6.35vw;
            font-weight: 400;
            letter-spacing: -0.005em;
          }
        }
        .desc_btn{
          position: absolute;
          left: 50%;
          transform: translate(-50%);
          padding-right: 7.222vw;
          width:98.5%;
          display: flex;
          justify-content: space-between;

          .btn {
            width: 38.888vw;
            height: 8.333vw;
            line-height: 8.333vw;
            text-align: center;
            color: #000000;
            border-radius: 0.278vw;
            text-shadow: 0px 0.278vw 0px #FFD43A;
            font-size: 5vw;
            font-weight: 700;
            letter-spacing: -0.05em;
            text-transform: capitalize;
            box-shadow: 0px -0.278vw 0px 0px #CEB223 inset;
            background: radial-gradient(101.6% 98.89% at 48.93% 1.12%, #EDE55F 0%, #D29F17 100%);
          }

          .btn-disable {
            width: 38.888vw;
            height: 8.333vw;
            line-height: 8.333vw;
            text-align: center;
            color: #535352;
            border-radius: 0.278vw;
            text-shadow: 0px 0.278vw 0px #FFD43A;
            font-size: 5vw;
            font-weight: 700;
            letter-spacing: -0.05em;
            text-transform: capitalize;
            box-shadow: 0px -0.278vw 0px 0px #CEB223 inset;
            background: radial-gradient(101.6% 98.89% at 48.93% 1.12%, #EDE55F 0%, #D29F17 100%);
            filter: grayscale(100%);
          }
        }
      }

      .sentenceBox1 {
        position: relative;
      }

      .copyCssEN {
        position: absolute;
        bottom: 1.35vw;
        left: 54vw;
        width: 3.386vw;
        height: 4.167vw;

        img {
          width: 100%;
          height: 100%;
        }
      }
      .copyCssIN {
        position: absolute;
        bottom: 1.35vw;
        left: 52.8vw;
        width: 3.386vw;
        height: 4.167vw;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .event2 {
      padding: 5.833vw 7.222vw 2vw 7.222vw;
      width: 100%;
      height: max-content;

      .e-img {
        position: relative;
        width: 85.277vw;

        img {
          width: 100%;
        }

        .word {
          position: absolute;
          top: 0;
          left: 15vw;
          color: #FFFFFF;
          text-shadow: 0px 0.35vw 0.35vw #BFBFBF;
          font-size: 5.833vw;
          font-style: italic;
          font-weight: 700;
          text-transform: capitalize;
        }
      }

      .desc {
        height: 63.888vw;
      }

      .sentenceBox2 {
        color: #FFFFFF;
        font-size: 3.888vw;
        font-weight: 400;
        line-height: 5.277vw;
      }

      .imgBox2 {
        position: relative;
        top: 5vw;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 82.222vw;
        }
      }
    }

    .event3 {
      padding: 2vw 7.222vw 0 7.222vw;
      width: 100%;
      height: max-content;

      .e-img {
        position: relative;
        width: 85.277vw;

        img {
          width: 100%;
        }

        .word {
          position: absolute;
          top: 0;
          left: 15vw;
          color: #FFFFFF;
          text-shadow: 0px 0.35vw 0.35vw #BFBFBF;
          font-size: 5.833vw;
          font-style: italic;
          font-weight: 700;
          text-transform: capitalize;
        }
      }

      .desc {
        height: 63.888vw;
      }
      .sentenceBox3 {
        color: #FFC90A;
        font-size: 3.888vw;
        font-weight: 400;
        line-height: 5.277vw;
      }

      .imgBox3 {
        position: relative;
        top: 2vw;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 82.222vw;
        }
      }

      .btnBox {
        position: relative;
        top:10vw;
        width: 100%;
        height: max-content;
        display: flex;
        justify-content: center;
        align-items: center;
        .btn{
          width: 80vw;
          height: 8.333vw;
          line-height: 8.333vw;
          text-align: center;
          color: #000000;
          border-radius: 0.3vw;
          text-shadow: 0px 0.278vw 0px #FFD43A;
          font-size: 5vw;
          font-weight: 700;
          letter-spacing: -0.05em;
          text-transform: capitalize;
          box-shadow: 0px -0.278vw 0px 0px #CEB223 inset;
          background:radial-gradient(101.6% 98.89% at 48.93% 1.12%, #EDE55F 0%, #D29F17 100%);
        }
      }
    }

    .cosmic{
      position: absolute;
      top: 270vw;
      width: 100vw;
      z-index: 0;
      img{
        width: 100vw;
      }
    }

    .sunlight {
      position: absolute;
      bottom: -1vw;
      width: 100vw;
      z-index: 0;

      img {
        width: 100vw;
      }
    }

    .newspaper{
      position: relative;
      top: 40vw;
      left: 8.146vw;
      width: 100%;
      overflow: hidden;
      img{
        width: 100vw;
      }
    }

    .bottom {
      position: absolute;
      bottom: 0;
      .bottom-word {
        position: absolute;
        bottom: 23.5vw;
        width: 100vw;
        color: #FFFFFF;
        font-size: 4.722vw;
        font-weight: 400;
        line-height: 6.388vw;
        text-align: center;
      }

      .bottom-img {
        position: absolute;
        bottom: 4.5vw;
        width: 100vw;
        display: flex;
        justify-content: center;
        img{
          width: 10vw;
        }
      }
    }
  }

}
.shadow {
  text-shadow: 0.5px 0.5px 0 #000000,
  -0.5px 0.5px 0 #000000,
    0.5px -0.5px 0 #000000,
    -0.5px -0.5px 0 #000000,
  0px 0.5px 0 #000000,
    0px -0.5px 0 #000000,
  -0.5px 0px 0 #000000,
  0.5px 0px 0 #000000,
  1px 1px 0 #000000,
  -1px 1px 0 #000000,
    1px -1px 0 #000000,
    -1px -1px 0 #000000,
  0px 1px 0 #000000,
    0px -1px 0 #000000,
  -1px 0px 0 #000000,
  1px 0px 0 #000000,
  0.5px 1px 0 #000000,
  -0.5px 1px 0 #000000,
    0.5px -1px 0 #000000,
    -0.5px -1px 0 #000000,
  1px 0.5px 0 #000000,
  -1px 0.5px 0 #000000,
    1px -0.5px 0 #000000,
    -1px -0.5px 0 #000000
}
</style>



// WEBPACK FOOTER //
// src/pages/FifthAnniversary/index.vue